<template>
  <div class="app-container contract-template-page">
    <el-form ref="queryForm" :model="queryParams" class="multipleSelectScroll template-query" v-show="showSearch" label-width="86px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="模板搜索" prop="keyword">
            <el-input v-model="queryParams.keyword" placeholder="编码/名称/关键词" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="模板类型" prop="templateType">
            <el-select v-model="queryParams.templateType" placeholder="请选择类型" clearable style="width:100%">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="状态" prop="status">
            <el-select v-model="queryParams.status" placeholder="请选择状态" clearable style="width:100%">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['crm:contractTemplate:save']" type="primary" icon="el-icon-plus" @click="handleAdd">
          新增模板
        </el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-row class="total-count">
      <span>模板总数：{{ summary.total }}</span>
      <span>启用：{{ summary.enabled }}</span>
      <span>待完善：{{ summary.pending }}</span>
      <span>停用：{{ summary.disabled }}</span>
    </el-row>

    <el-table v-loading="loading" :data="dataList" height="calc(100vh - 300px)" @row-dblclick="handleEdit">
      <el-table-column label="模板编码" prop="templateCode" min-width="210" fixed="left" show-overflow-tooltip />
      <el-table-column label="模板名称" prop="templateName" min-width="180" fixed="left" show-overflow-tooltip />
      <el-table-column label="合同标题" prop="title" min-width="160" show-overflow-tooltip />
      <el-table-column label="类型" width="120" align="center">
        <template slot-scope="scope">{{ typeText(scope.row.templateType) }}</template>
      </el-table-column>
      <el-table-column label="适用品类关键词" prop="applicableKeywords" min-width="240" show-overflow-tooltip />
      <el-table-column label="版本" prop="versionNo" width="80" align="center" />
      <el-table-column label="排序" prop="sortNo" width="80" align="center" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="statusTag(scope.row.status)" size="mini">{{ statusText(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" prop="updateTime" width="160" align="center" />
      <el-table-column label="操作" width="150" fixed="right" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button v-hasPermi="['crm:contractTemplate:save']" type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button v-hasPermi="['crm:contractTemplate:remove']" type="text" class="danger" @click="handleRemove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="formTitle" :visible.sync="formOpen" width="980px" append-to-body :close-on-click-modal="false">
      <el-alert
        class="field-help"
        type="info"
        :closable="false"
        show-icon
        title="这里维护报价转合同生成草稿时使用的合同模板。适用品类关键词命中报价商品后，系统会自动选择对应模板；未命中时使用通用采购模板。"
      />
      <el-form ref="templateForm" :model="form" :rules="rules" label-width="118px" class="template-form">
        <el-row :gutter="12">
          <el-col :xs="24" :md="12">
            <el-form-item label="模板编码" prop="templateCode">
              <el-input v-model="form.templateCode" maxlength="80" placeholder="例如 RJT_CONTRACT_MEMBRANE_MODULE" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="模板名称" prop="templateName">
              <el-input v-model="form.templateName" maxlength="120" placeholder="例如 膜组件采购合同模板" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="模板类型" prop="templateType">
              <el-select v-model="form.templateType" placeholder="请选择模板类型" style="width:100%">
                <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="合同标题" prop="title">
              <el-input v-model="form.title" maxlength="120" placeholder="生成合同草稿顶部显示的标题" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8">
            <el-form-item label="文件简称">
              <el-input v-model="form.shortName" maxlength="50" placeholder="下载文件名前缀" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8">
            <el-form-item label="版本">
              <el-input v-model="form.versionNo" maxlength="30" placeholder="V1" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8">
            <el-form-item label="排序">
              <el-input-number v-model="form.sortNo" :min="1" :max="999" controls-position="right" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="8">
            <el-form-item label="状态" prop="status">
              <el-select v-model="form.status" placeholder="请选择状态" style="width:100%">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="16">
            <el-form-item label="适用品类关键词" prop="applicableKeywords">
              <el-input v-model="form.applicableKeywords" maxlength="500" placeholder="用逗号分隔，例如 膜组件,组件,中空膜" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="交货条款">
              <el-input v-model="form.deliveryClause" type="textarea" :rows="3" maxlength="2000" show-word-limit placeholder="生成合同草稿的交货、运输、包装条款" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="验收质保条款">
              <el-input v-model="form.qualityClause" type="textarea" :rows="4" maxlength="3000" show-word-limit placeholder="生成合同草稿的验收、质量、质保条款" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件提示">
              <el-input v-model="form.appendix" type="textarea" :rows="2" maxlength="1000" show-word-limit placeholder="提示需要随合同确认的报价单、技术协议、清单等附件" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="1000" show-word-limit placeholder="内部维护说明，不直接作为合同正文" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="formOpen = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getContractTemplateDetail,
  listContractTemplates,
  removeContractTemplate,
  saveContractTemplate
} from '@/api/crm/contractTemplate'

const emptyForm = () => ({
  id: null,
  templateCode: '',
  templateName: '',
  templateType: 'COMMON',
  shortName: '',
  title: '',
  applicableKeywords: '',
  versionNo: 'V1',
  status: 1,
  sortNo: 100,
  deliveryClause: '',
  qualityClause: '',
  appendix: '',
  remark: ''
})

export default {
  name: 'ContractTemplate',
  data() {
    return {
      loading: false,
      submitLoading: false,
      showSearch: true,
      formOpen: false,
      dataList: [],
      queryParams: {
        keyword: '',
        templateType: '',
        status: null
      },
      form: emptyForm(),
      typeOptions: [
        { value: 'MEMBRANE_MODULE', label: '膜组件' },
        { value: 'MEMBRANE_ELEMENT', label: '膜元件/膜片' },
        { value: 'ACCESSORY', label: '膜配件/备件' },
        { value: 'SERVICE', label: '服务类' },
        { value: 'EQUIPMENT', label: '设备/一体化' },
        { value: 'COMMON', label: '通用采购' }
      ],
      statusOptions: [
        { value: 1, label: '启用' },
        { value: 2, label: '待完善' },
        { value: 3, label: '停用' }
      ],
      rules: {
        templateCode: [{ required: true, message: '模板编码不能为空', trigger: 'blur' }],
        templateName: [{ required: true, message: '模板名称不能为空', trigger: 'blur' }],
        templateType: [{ required: true, message: '模板类型不能为空', trigger: 'change' }],
        title: [{ required: true, message: '合同标题不能为空', trigger: 'blur' }],
        applicableKeywords: [{ required: true, message: '适用品类关键词不能为空', trigger: 'blur' }],
        status: [{ required: true, message: '状态不能为空', trigger: 'change' }]
      }
    }
  },
  computed: {
    formTitle() {
      return this.form.id ? '编辑合同模板' : '新增合同模板'
    },
    summary() {
      return {
        total: this.dataList.length,
        enabled: this.dataList.filter(item => Number(item.status) === 1).length,
        pending: this.dataList.filter(item => Number(item.status) === 2).length,
        disabled: this.dataList.filter(item => Number(item.status) === 3).length
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      listContractTemplates(this.cleanParams(this.queryParams))
        .then(response => {
          this.dataList = (response && response.data) || []
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleQuery() {
      this.getList()
    },
    resetQuery() {
      this.queryParams = {
        keyword: '',
        templateType: '',
        status: null
      }
      this.getList()
    },
    handleAdd() {
      this.form = emptyForm()
      this.formOpen = true
      this.$nextTick(() => this.clearValidate())
    },
    handleEdit(row) {
      if (!row || !row.id) {
        return
      }
      getContractTemplateDetail(row.id).then(response => {
        this.form = {
          ...emptyForm(),
          ...((response && response.data) || {})
        }
        this.formOpen = true
        this.$nextTick(() => this.clearValidate())
      })
    },
    submitForm() {
      this.$refs.templateForm.validate(valid => {
        if (!valid) {
          return
        }
        this.submitLoading = true
        saveContractTemplate(this.form)
          .then(() => {
            this.$message.success('保存成功')
            this.formOpen = false
            this.getList()
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    },
    handleRemove(row) {
      if (!row || !row.id) {
        return
      }
      this.$confirm(`确认删除合同模板「${row.templateName || row.templateCode}」？`, '提示', {
        type: 'warning'
      }).then(() => {
        return removeContractTemplate(row.id)
      }).then(() => {
        this.$message.success('删除成功')
        this.getList()
      }).catch(() => {})
    },
    clearValidate() {
      if (this.$refs.templateForm) {
        this.$refs.templateForm.clearValidate()
      }
    },
    cleanParams(params) {
      const result = {}
      Object.keys(params || {}).forEach(key => {
        const value = params[key]
        if (value !== '' && value !== null && value !== undefined) {
          result[key] = value
        }
      })
      return result
    },
    typeText(value) {
      const item = this.typeOptions.find(option => option.value === value)
      return item ? item.label : (value || '-')
    },
    statusText(value) {
      const map = { 1: '启用', 2: '待完善', 3: '停用' }
      return map[Number(value)] || '待完善'
    },
    statusTag(value) {
      const map = { 1: 'success', 2: 'warning', 3: 'info' }
      return map[Number(value)] || 'warning'
    }
  }
}
</script>

<style scoped>
.contract-template-page {
  background: #fff;
}

.template-query {
  margin-bottom: 8px;
}

.total-count {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  padding: 10px 12px;
  margin-bottom: 10px;
  color: #5f6b7a;
  background: #f7f9fc;
  border: 1px solid #e6ebf2;
}

.field-help {
  margin-bottom: 14px;
}

.template-form {
  padding-right: 8px;
}

.danger {
  color: #f56c6c;
}
</style>
